import Quill from "quill";
import type { EmbedBlot } from "parchment";
import { Gif } from "../gifpicker/gif.types";

const Embed = Quill.import("blots/block/embed") as typeof EmbedBlot;

class GifBlot extends Embed {

    static override blotName = 'tm-gif';
    static override tagName = 'img';

    static override create(gif: Gif) {
        const node: HTMLImageElement = <HTMLImageElement>super.create();

        if (gif && gif.url) {
            node.setAttribute('src', gif.url)
        } else if (gif && typeof gif === "string") {
            node.setAttribute('src', gif)
        }
        return node;
    }

    static override value(node) {
        return {
            url: node.getAttribute('src')
        };
    }
}

export default GifBlot;